import React from 'react';

export interface ProgressBarProps {
  /** Percent complete, 0–100. Values outside the range are clamped. */
  value: number;
  /** Accessible name for the bar, e.g. "Uploading files". */
  label: string;
  className?: string;
}

/**
 * A determinate progress bar for uploads and other long transfers.
 *
 * Owns the track, the fill and the ARIA wiring, so every progress indicator in
 * the app looks and reads the same instead of each screen drawing its own.
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({ value, label, className = '' }) => {
  const percent = Math.min(100, Math.max(0, Math.round(value)));

  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      className={`w-full h-bg-v2-xs bg-bg-quaternary rounded-bg-v2-full overflow-hidden ${className}`}
    >
      <div
        className="h-full bg-bg-brand-solid rounded-bg-v2-full transition-all"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
};

export default ProgressBar;
